<template>
  <div id="app">
    <div v-bind:id="[currentUser ? 'wrapper' : '']"  >
      <Navigation v-if="currentUser && !['Login', 'AddInfo', 'ExamPage'].includes($route.name)"></Navigation>
      <!-- Content Wrapper -->
      <div  v-bind:id="[currentUser ? 'content-wrapper' : '']" v-bind:class="[currentUser ? 'd-flex flex-column' : '']">

        <!-- Main Content -->
        <div v-bind:id="[currentUser ? 'content' : '']">
          <ContentNavBar v-if="currentUser && !['Login'].includes($route.name) && !['ExamPage'].includes($route.name)"></ContentNavBar>
          

          <router-view/>

        </div>
        <!-- End of Main Content -->

        <Footer v-if="currentUser"></Footer>

      </div>
      <!-- End of Content Wrapper -->
      
    </div>
   
    <!-- Scroll to Top Button-->
    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>

    <!-- Logout Modal-->
    <!-- <div class="modal fade" id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">Select "Logout" below if you are ready to end your current session.</div>
          <div class="modal-footer">
            <button class="btn btn-secondary" type="button" data-dismiss="modal">Cancel</button>
            <a class="btn btn-primary" href="login.html">Logout</a>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import Navigation from './components/Navigation.vue'
import ContentNavBar from './components/ContentNavBar.vue'
import Footer from './components/Footer.vue'
import Login from './components/login/Login.vue'
import { mapState } from 'vuex'


export default {
  name: 'app',
  components: {
    Navigation,
    ContentNavBar,
    Footer,
    Login
  },
  computed: {
      ...mapState(['currentUser'])
  }
}
</script>